import FooterCTA from '@modules/layout/components/footer-cta'
import FooterNav from '@modules/layout/components/footer-nav'
import MedusaCTA from '@modules/layout/components/medusa-cta'

const Footer = () => {
  return (
    <footer>
      <FooterCTA />
      <FooterNav />
      <MedusaCTA />
    </footer>
  )
}

export default Footer
